<template>
  <div id="right-1">
    <div class="area-title">
      <span>每日营业额</span>
    </div>
    <div class="area-padding" ref="rightTop"></div>
  </div>
</template>
<script>
export default {
  props: ["level", "regionId", "deviceType"],
  data() {
    return {
      timerId: null, //定时器的标识
      rightTopChart: null,
      xData: [],
      barData: [],
      lineData: [],
    };
  },
  mounted() {
    this.initChart();
    this.getData();
  },
  methods: {
    // 初始化echarts实例对象
    initChart() {
      this.rightTopChart = this.$echarts.init(this.$refs.rightTop);
    },
    // 获取服务器数据
    getData() {
      this.$http({
        url: this.$http.adornUrl("/admin/api/busi/stat/dailyTurnover"),
        method: "get",
        params: this.$http.adornParams({
          level: this.level,
          regionId: this.regionId,
        }),
      }).then(({ data }) => {
        console.log(data,'每日营业额')
        if (data.code == 0) {
          this.xData = data.data.times;
          this.barData = data.data.bicycleturnoverTotals;
          this.lineData = data.data.carBicycleturnoverTotals;
          this.updateChart();
          // 启动定时器
          // this.startInterval();
        }
      });
    },
    // 更新图表
    updateChart() {
      var option = {
        legend: {
          show: true,
          right: 20,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: "#fff",
            fontSize: 10,
          },
        },
        grid: {
          left: "0%",
          right: "0%",
          bottom: "12%",
          top: "12%",
          containLabel: true,
        },
        xAxis: {
          data: this.xData,
          // data:['11-25', '11-25', '11-25', '11-25', '11-25', '11-25', '11-25'],
          axisLine: {
            lineStyle: {
              color: "#B4B4B4",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: [
          {
            name: "元",
            type: "value",
            splitLine: { show: false },
            axisLine: {
              lineStyle: {
                color: "#B4B4B4",
              },
            },
            axisLabel: {
              formatter: "{value} ",
            },
          },
        ],
        series: [
          {
            name: "充电自行车",
            type: "bar",
            barWidth: 12,
            stack: "one",
            itemStyle: {
              normal: {
                // barBorderRadius: [5,5,0,0],
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#72B4FA" },
                  { offset: 1, color: "#3E7DF2" },
                ]),
              },
            },
            data: this.barData,
            // data: [6000.55, 5000.55, 2000.55, 0, 6.55, 6.55, 6.55],
          },
          {
            name: "充电汽车",
            type: "bar",
            // barGap: "-100%",
            stack: "one",

            barWidth: 15,
            itemStyle: {
              normal: {
                // barBorderRadius: 10,
                barBorderRadius: [5, 5, 0, 0],
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#FFF8C8" },
                  { offset: 1, color: "#F7B500 " },
                ]),
              },
            },
            // z: -12,
            data: this.lineData,
            // data: [27.26, 27.26, 27.26, 27.26, 10.28, 10.28, 10.28],
          },
        ],
      };
      this.rightTopChart.setOption(option);
    },
    // 定时器
    // startInterval() {
    //   if (this.timerId) {
    //     clearInterval(this.timerId);
    //   }
    //   this.timerId = setInterval(() => {
    //     this.xData = [];
    //     this.barData = [];
    //     this.lineData = [];
    //     this.getData();
    //   }, 1000 * 60 * 10);
    // },
  },
};
</script>
<style lang="scss" scoped>
$box-height: 288px;
$box-width: 480px;
#right-1 {
  min-width: $box-width;
  height: 288px;
  // border: 1px solid red;
  .area-title {
    width: 284px;
    height: 32px;
    background: url("../../assets/pgzl-ranking-bg.png");
    background-size: cover;
    background-position: center center;
    color: #fff;
    font-size: 14px;
    line-height: 32px;
    span {
      margin-left: 40px;
    }
  }
  .area-padding {
    margin-top: 32px;
    padding: 0 16px;
    height: 256px;
    width: 100%;
    overflow: hidden;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index/right-1.vue